import React, { useEffect, useCallback } from "react";
import styles from "./ReelsCategory.module.css";
import { useAtom } from "jotai";
import { useCheckLogin } from "@/hooks";
import {
  reelsCategoryState,
  defaultReelsCategoryState,
  reelsCategoeryKeyowrd,
} from "../state";
import {
  ImageList,
  BottomNavigationBar,
  useConfirm,
  SearchBar,
  Header,
} from "@components";
import Axios from "@/Axios";
import { useNavigate } from "react-router-dom";
import { INSERT_TAG } from "..";
import {
  useLoadReset,
  useDebouncedCallback,
  useDimLoading,
  useDimLoadComplete,
} from "@/hooks";

export default function ReelsCategory() {
  const dimLoadComplete = useDimLoadComplete();
  const dimLoading = useDimLoading();
  const loadReset = useLoadReset();
  const confirm = useConfirm();
  const [state, setState] = useAtom(reelsCategoryState);
  const [keyword, setKeyword] = useAtom(reelsCategoeryKeyowrd);
  const checkLogin = useCheckLogin();
  const navigate = useNavigate();

  const resetState = () => {
    setState(() => ({ ...defaultReelsCategoryState }));
    loadReset();
  };
  const turnIntoUpdate = () => {
    setState((s) => ({
      ...s,
      isUpdate: true,
    }));
  };
  const updateToNormal = () => {
    setState((s) => ({
      ...s,
      isUpdate: false,
    }));
  };
  const turnIntoDelete = () => {
    setState((s) => ({
      ...s,
      isDelete: true,
      isReset: false,
      isDim: true,
    }));
  };
  const deleteToNormal = () => {
    setState((s) => ({
      ...s,
      isDelete: false,
      isReset: true,
      isDim: false,
    }));
  };
  const getAllCategory = () => {
    Axios.get("/api/reels-category", { params: {} }).then((res) => {
      if (res.data?.errMsg) {
        confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        return;
      }
      if (!res.data?.reelsCategorys) {
        setState((s) => ({ ...s, list: [] }));
        return;
      }
      const list = res.data?.reelsCategorys.map((data) => ({
        ...data,
        id: data.index,
        title: data.categoryNm,
      }));
      setState((s) => ({ ...s, list }));
    });
  };

  const getCategory = useDebouncedCallback(() => {
    dimLoading();
    Axios.get("/api/reels-category/search", {
      params: { keyword },
    }).then((res) => {
      if (res.data?.errMsg) {
        dimLoadComplete();
        confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        return;
      }
      if (!res.data?.reelsCategorys) {
        setState((s) => ({ ...s, list: [] }));
        dimLoadComplete();
        return;
      }
      const list = res.data?.reelsCategorys.map((data) => ({
        ...data,
        id: data.index,
        title: data.categoryNm,
      }));
      setState((s) => ({ ...s, list }));
      dimLoadComplete();
    });
  });

  const keywordSearch = (e) => {
    setKeyword(e.target.value);
    if (e.key === "Enter") {
      getCategory();
      e.target.blur();
    }
  };

  const toInsert = () => {
    navigate("/reels-category-upsert/" + INSERT_TAG);
  };

  const deleteInfo = useDebouncedCallback(() => {
    confirm("정말로 삭제하시겠습니까?", () => {
      if (!state.deletes?.length) {
        confirm("삭제할 대상이 존재하지 않습니다.");
        return;
      }

      dimLoading();
      Axios.post("/api/reels-category/delete", {
        reelsCategorys: state.deletes,
      }).then((res) => {
        if (res.data?.errMsg) {
          dimLoadComplete(() => {
            confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
          });
          return;
        }
        setState((s) => ({
          ...defaultReelsCategoryState,
          isLogin: s.isLogin,
        }));
        getAllCategory();
        dimLoadComplete(() => {
          confirm("삭제를 완료했습니다.");
        });
      });
    });
  });

  const setDeletes = useCallback((d) => {
    setState((s) => ({ ...s, deletes: [...s?.deletes, d] }));
  }, []);
  const resetDeletes = useCallback((d) => {
    setState((s) => ({
      ...s,
      deletes: [...s?.deletes].filter((obj) => obj.index !== d.index),
    }));
  }, []);

  // 최초 한번 실행행
  useEffect(() => {
    getAllCategory();
    const callbackId = checkLogin(
      () => {
        setState((s) => ({ ...s, isLogin: true }));
      },
      () => {
        setState((s) => ({ ...s, isLogin: false }));
      }
    );
    return () => {
      cancelIdleCallback(callbackId);
      resetState();
    };
  }, []);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <div className={styles.titleSearch}>
            <Header title="릴스 모아보기" />
            <SearchBar keywordSearch={keywordSearch} />
            {state.isDim && <div className={styles.topDim} />}
          </div>
          <div className={styles.contentFooter}>
            <div className={styles.content}>
              <div className={styles.subBtn}>
                <span className={styles.category}>카테고리</span>
                {state.isLogin && !state.isUpdate && !state.isDelete && (
                  <>
                    <button className={styles.updateBtn} onClick={toInsert}>
                      <span className={styles.update}>등록</span>
                    </button>
                    <button
                      className={styles.updateBtn}
                      onClick={turnIntoUpdate}
                    >
                      <span className={styles.update}>수정</span>
                    </button>
                    <button
                      className={styles.deleteBtn}
                      onClick={turnIntoDelete}
                    >
                      <span className={styles.delete}>삭제</span>
                    </button>
                  </>
                )}
                {state.isUpdate && (
                  <>
                    <div className={styles.deleting}>
                      <span className={styles.deleting1}>수정중...</span>
                    </div>
                    <div className={styles.deleting}></div>
                    <button
                      className={styles.cancelBtn}
                      onClick={updateToNormal}
                    >
                      <span className={styles.cancel}>취소</span>
                    </button>
                  </>
                )}
                {state.isDelete && (
                  <>
                    <div className={styles.deleting}>
                      <span className={styles.deleting1}>삭제중...</span>
                    </div>
                    <button className={styles.deleteBtn} onClick={deleteInfo}>
                      <span className={styles.delete}>삭제</span>
                    </button>
                    <button
                      className={styles.cancelBtn}
                      onClick={deleteToNormal}
                    >
                      <span className={styles.cancel}>취소</span>
                    </button>
                  </>
                )}
              </div>
              <ImageList
                list={state.list}
                defaultUrl={"/reels-list"}
                updateUrl={"/reels-category-upsert"}
                isUpdate={state.isUpdate}
                isDelete={state.isDelete}
                isReset={state.isReset}
                setDeletes={setDeletes}
                resetDeletes={resetDeletes}
              />
            </div>
          </div>
        </div>
        <div className={styles.footerContainer}>
          <BottomNavigationBar />
          {state.isDim && <div className={styles.bottomDimmed} />}
        </div>
      </div>
    </div>
  );
}
